<template>
  <div class="container customer_container">
    <swiper :swiperArray="swiperArray" />
    <div class="content-box">
      <div class="content" v-for="(item, i) in array" :key="i">
        <h3 class="title">{{ item.title }}</h3>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
    <aboutUs />
  </div>
</template>

<script>
import swiper from "../../components/swiper";
import aboutUs from "../../components/contact";
export default {
  components: { swiper, aboutUs },
  data() {
    //这里存放数据
    return {
      swiperArray: [
        { id: 0, src: require("../../assets/img/banner/banner11.jpg") },
        { id: 1, src: require("../../assets/img/banner/banner2.jpg") },
        { id: 2, src: require("../../assets/img/banner/banner1.jpg") },
        { id: 3, src: require("../../assets/img/banner/banner2.jpg") },
      ],
      text: "圣妖传360官网 |",
      text1: "圣妖传37官网 |",
      text2: "圣妖传9377官网",
      array: [],
    };
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  created() {
    this.getData();
  },
  mounted() {},
  //方法集合
  methods: {
    getData() {
      this.array = [
        {
          id: 0,
          title: "如何登录游戏？",
          desc:
            "您可以点击 " +
            this.text +
            " " +
            this.text1 +
            " " +
            this.text2 +
            " 等链接进入游戏的网页",
        },
        {
          id: 1,
          title: "可以使用电脑进行游戏吗？",
          desc:
            "都是可以使用电脑进行游戏的哦，点击上面官网链接您就可以进行愉快的游戏啦~",
        },
        {
          id: 2,
          title:
            "如何绑定手机？绑定手机号有什么益处呢？一个手机号可以绑定几个账号？",
          desc:
            "您在登录界面登录成功后就会跳到绑定手机界面呢，输入完您想要绑定的手机号码，并发送验证码到您的手机上，输入正确后就大功告成啦~ 绑定手机号后可以通过系统发送验证码帮助您快速的重置密码，妈妈再也不怕我忘记密码啦~ 注意：一个手机号只能绑定一个账号哦！",
        },
        {
          id: 3,
          title: "可以更换并解绑手机号码吗？",
          desc: "为了您的游戏财产安全，目前不可以更换并解绑手机号哦~",
        },
        {
          id: 5,
          title: "为什么我的账号登录时提示被锁定了？",
          desc:
            "肯定是您重复输错密码啦，重复输错密码五次以上账号就会被锁定哦，时间为30分钟，期间您是无法登陆游戏的哦，这样的情况您只需要等待耐心30分钟就可以再次登陆游戏啦~ 为了您的游戏财产安全，请勿将您的账号与密码随意的告诉陌生人哦~",
        },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
